export default {
  title: {
    en: 'YOUR SUBSCRIPTION HAS BEEN PAUSED FOR 1 MONTH',
  },
  text: {
    en: `
      <p>We’ll miss you!</p> 
      <p>You can still check out fragrances and add them to your queue for the&nbsp;future.</p><br />
      <p>Your account will be reactivated in a month. Your next charge will&nbsp;be&nbsp;on&nbsp;{nextBillingDate}</p> 
    `,
  },
  okButton: {
    en: 'OK, I understand',
  },
  didNotMean: {
    en: 'Didn’t mean to pause?',
  },
  reactivateButton: {
    en: 'Reactivate my account, please!',
  },
}
